module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-main/widget-detail-main.component.scss
// module id = ./src/app/widgets/widget-detail/widget-detail-main/widget-detail-main.component.scss
// module chunks = main